"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNABLE_MESSAGE_TYPES = new Set(['PLAIN_TEXT', 'CUSTOM_TRANSACTION', 'CUSTOM_DATA']);
//# sourceMappingURL=SignableMessages.js.map